module.exports = __webpack_public_path__ + "img/bind3.523d4538.jpg";